"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_modal_1 = __importDefault(require("react-modal"));
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const InputWeb_1 = __importDefault(require("../common/InputWeb"));
const ButtonWeb_1 = __importDefault(require("../common/ButtonWeb"));
const react_redux_1 = require("react-redux");
const account_1 = require("../../store/redux/account");
const pilotHandlers_1 = require("../../handlers/pilotHandlers");
const selectors_1 = require("../../store/redux/selectors");
const react_select_1 = __importDefault(require("react-select"));
const lodash_1 = require("lodash");
const helper_1 = require("../../services/helper");
const PilotLicenseModal = ({ modalVisible, setModalVisible, userIsPilot, licenseData }) => {
    const initialState = {
        flied_hours: null,
        number: '',
        types: [],
        company: ''
    };
    const [data, setData] = (0, react_1.useState)(initialState);
    (0, react_1.useEffect)(() => {
        !(0, lodash_1.isEmpty)(licenseData) && setData(licenseData);
        (0, pilotHandlers_1.getLicenseTypesHandler)();
    }, []);
    const dispatch = (0, react_redux_1.useDispatch)();
    const [t] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: 'account.set_profile' });
    const licenseTypes = (0, react_redux_1.useSelector)(selectors_1.getLicenseTypes).map(type => ({
        label: type.name,
        value: type.id
    }));
    return ((0, jsx_runtime_1.jsxs)(react_modal_1.default, { isOpen: modalVisible, onRequestClose: () => {
            setModalVisible(false);
            setData(initialState);
        }, contentLabel: "Pilot details", className: "modal-body", overlayClassName: "modal-overlay", appElement: document.getElementById("app-root"), children: [(0, jsx_runtime_1.jsx)("span", { className: "subtitle-bold", children: t('license.header') }), (0, jsx_runtime_1.jsxs)("div", { className: "content", children: [(0, jsx_runtime_1.jsx)(InputWeb_1.default, { value: data, label: t('license.number'), name: "number", onChange: setData, placeholder: t('license.enter_number') }), (0, jsx_runtime_1.jsx)(InputWeb_1.default, { value: data, label: t('license.company'), name: "company", onChange: setData, placeholder: t('license.company') }), (0, jsx_runtime_1.jsx)("div", { className: "input-box", children: (0, jsx_runtime_1.jsxs)("label", { className: "input-label", children: [t('license.type'), (0, jsx_runtime_1.jsx)(react_select_1.default, { options: licenseTypes, isMulti: true, classNamePrefix: "select", className: "select", placeholder: t('license.enter_type'), value: data.types?.map(type => ({ value: type.id, label: type.name })), onChange: (selectedOptions) => {
                                        const selectedTypes = selectedOptions.map(option => ({
                                            id: option.value,
                                            name: option.label
                                        }));
                                        setData({ ...data, types: selectedTypes });
                                    } })] }) }), (0, jsx_runtime_1.jsx)(InputWeb_1.default, { value: data, type: "number", label: t('license.flied_hours'), name: "flied_hours", onChange: setData, placeholder: t('license.enter_flied_hours') })] }), (0, jsx_runtime_1.jsxs)("div", { className: "buttons", children: [(0, jsx_runtime_1.jsx)(ButtonWeb_1.default, { type: "Blue", fullWidth: true, isDisabled: !(0, helper_1.setLicenseButtonValidation)(data, licenseData, userIsPilot), onClick: () => {
                            userIsPilot ?
                                (0, helper_1.editExistingLicense)(data, licenseData) :
                                dispatch((0, account_1.setPilotProfileAction)({ license: data }));
                            setModalVisible(false);
                        }, children: t('save') }), (0, jsx_runtime_1.jsx)(ButtonWeb_1.default, { type: "White-BlueFont", fullWidth: true, onClick: () => {
                            setModalVisible(false);
                            setData(initialState);
                        }, children: t('cancel') })] })] }));
};
exports.default = PilotLicenseModal;
